// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1XiiO","boxTitle":"Qualiphy_boxTitle__1gft3","box":"Qualiphy_box__33TPw","toggleWrap":"Qualiphy_toggleWrap__2ApKd"};